import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdvancedDataSource } from 'src/app/controls/advanced-gridview/datasources/advanced-datasource';
import { AdvancedGridviewModel } from 'src/app/controls/advanced-gridview/models/advanced-gridview-model';
import { ColumnDefinition } from 'src/app/controls/advanced-gridview/models/column-definition';
import { ColumnListDefinition } from 'src/app/controls/advanced-gridview/models/column-list-definition';
import { ColumnType } from 'src/app/controls/advanced-gridview/models/column-type';
import { MenuITemAction } from 'src/app/controls/advanced-gridview/models/menu-item-action';
import { MenuItemEvent } from 'src/app/controls/advanced-gridview/models/menu-item-event';
import { SortInfos } from 'src/app/controls/advanced-gridview/models/sort-infos';
import { FilterType } from 'src/app/controls/filters/models/filter-type';
import { ListItem } from 'src/app/controls/filters/models/list-item';
import { DefaultListComponent } from 'src/app/controls/list/default-list/default-list.component';
import { FaillureType } from 'src/app/models/enums/faillure-type';
import { LogSupervisionEntry } from 'src/app/models/log-supervision-entry';
import { MailConnectorError } from 'src/app/models/mail-connector-error';
import { MailConnectorErrorService } from 'src/app/services/mail-connector-error.service';
import { MemoryService } from 'src/app/services/memory.service';
import { NotificationService } from 'src/app/services/notification-service';
import { AdvancedGridviewComponent } from '../../controls/advanced-gridview/advanced-gridview.component';
import { MailConnectorErrorDialogComponent } from './mail-connector-error-dialog/mail-connector-error-dialog.component';

@Component({
    selector: 'app-mail-connector-error-supervision',
    templateUrl: './mail-connector-error-supervision.component.html',
    styleUrls: ['./mail-connector-error-supervision.component.scss'],
    imports: [AdvancedGridviewComponent]
})
export class MailConnectorErrorSupervisionComponent extends DefaultListComponent<MailConnectorError> implements OnInit {
    public logs: LogSupervisionEntry[];

    /**
     * Configuration des colonnes de la liste.
     */
    tableConfig: ColumnDefinition[] = null;

    faillureTypeValues: ListItem<string>[] = [
        new ListItem(FaillureType.ChannelNotFound.toString(), 'Canal de réception non trouvé'),
        new ListItem(FaillureType.EmlReadingFail.toString(), 'Echec de lecture du mail'),
        new ListItem(FaillureType.FolderCreationFail.toString(), 'Echec de création du dossier'),
        new ListItem(FaillureType.FinalizationFail.toString(), 'Echec de finalisation'),
        new ListItem(FaillureType.AttributeAssignmentFail.toString(), "Echec d'alimentation des attributs"),
        new ListItem(FaillureType.CustomerIdentificationFail.toString(), "Echec d'identification du client"),
        new ListItem(FaillureType.DocumentIdentificationFail.toString(), "Echec d'identification du document"),
        new ListItem(FaillureType.ChannelRetrivingFail.toString(), 'Echec de determination du canal de réception'),
        new ListItem(FaillureType.RoutingFail.toString(), 'Echec de routage'),
        new ListItem(FaillureType.AutoLinkFail.toString(), 'Echec de rattachement'),
        new ListItem(FaillureType.AddressInactive.toString(), "L'adresse du canal de réception est inactive"),
    ];

    constructor(
        public override dialog: MatDialog,
        protected override memoryService: MemoryService,
        private mailConnectorErrorService: MailConnectorErrorService,
        private spinner: NgxSpinnerService,
        private notificationService: NotificationService
    ) {
        super(dialog, memoryService);

        this.tableConfig = [
            new ColumnDefinition('date', 'Date', ColumnType.DateAndTime, FilterType.Date, 1, 9, true),
            new ColumnListDefinition('faillureType', "Type d'erreur", FilterType.List, 2, 15, true, false, this.faillureTypeValues),
            new ColumnDefinition('taskId', 'Id tache', ColumnType.Text, FilterType.Text, 3, 17, true),
            new ColumnDefinition('filePath', 'Chemin du fichier', ColumnType.Text, FilterType.Text, 4, 30, true),
            new ColumnDefinition('mailToAddresses', 'Destinataires', ColumnType.Text, FilterType.Text, 4, 15, true),
            new ColumnDefinition('organizationId', 'Organisation', ColumnType.Text, FilterType.Text, 5, 8, true),
            new ColumnDefinition('channelId', 'Canal de réception', ColumnType.Numeric, FilterType.Numeric, 6, 5, true),
        ];
    }

    ngOnInit(): void {
        // this.LogSupervisionService.List(null, null, null, null, 0, 100).subscribe(
        //   x => {
        //     this.logs = x.value;
        //   }
        // );

        this.dataSource = new AdvancedDataSource(null, this.mailConnectorErrorService, this.spinner, this.notificationService);
        this.filteredTableModel = new AdvancedGridviewModel(this.tableConfig, new SortInfos('date', 'desc'), false);
    }

    /**
     * Appellé lorsque l'utilisateur clique sur un élément du menu contextuel.
     * @param event : Événement retourné par le menu contextuel.
     */
    public onAction(event: MenuItemEvent<MailConnectorError>): void {
        if (event.action == MenuITemAction.Read) {
            // Cas de la consultation.
            console.log('consulter');
            this.displayDetailDialog(event.context);
        }
    }

    /**
     * Affiche la boite de dialogue du détail de l'erreur.
     */
    protected displayDetailDialog(record: MailConnectorError) {
        const dialogRef = this.dialog.open(MailConnectorErrorDialogComponent, {
            maxWidth: '400px',
            data: {
                record: record,
            },
            panelClass: 'empty-dialog',
        });

        // Attente de la réponse de la boite de dialogue.
        dialogRef.afterClosed().subscribe((dialogResult) => {});
    }
}
